

// import React, { useState, useEffect } from "react";
// import Select from "react-select";
// import { Col, Row } from "react-bootstrap";
// import { CMS_maati } from "urlconfig";

// const OliveLocationFilters = ({
//   onChange,
//   GpRequired = true,
//   majraRequired = true,
//   width = 4,
//   firstDistrict,
//   firstBlock,
//   firstgp,
// }) => {
//   const [locationData, setLocationData] = useState([]);
//   const [districtValue, setDistrictValue] = useState(null);
//   const [blockValue, setBlockValue] = useState(null);
//   const [gpValue, setGpValue] = useState(null);
//   const [majraValue, setMajraValue] = useState(null);

//   useEffect(() => {
   
//         fetch(`${CMS_maati}/api/alaap-location-masters`)
    
//       .then((res) => res.json())
//       .then((data) => setLocationData(data?.data))
//       .catch((err) => console.error("Error fetching location data:", err));
//   }, []);
//   console.log("locationData",locationData)

//   useEffect(() => {
//     if (firstDistrict && locationData?.length > 0) {
//       const district = locationData?.find(
//         (d) =>
//           d.value === firstDistrict ||
//           d.label === firstDistrict ||
//           d.label?.includes(firstDistrict) ||
//           firstDistrict?.includes(d.label)
//       );
//       if (district) {
//         const districtOption = { label: district.label, value: district.value };
//         setDistrictValue(districtOption);
//         setBlockValue(null);
//         setGpValue(null);
//         setMajraValue(null);
//         onChange({
//           district: districtOption,
//           block: null,
//           grampanchayat: null,
//           majra: null,
//         });
//       }
//     }
//   }, [firstDistrict, locationData]);

//   useEffect(() => {
//     if (firstBlock && districtValue && locationData?.length > 0) {
//       const district = locationData?.find(
//         (d) => d.value === districtValue.value
//       );
//       const block = district?.blocks?.find(
//         (b) =>
//           b.value === firstBlock ||
//           b.label === firstBlock ||
//           b.label?.includes(firstBlock)
//       );

//       if (block) {
//         const blockOption = { label: block.label, value: block.value };
//         setBlockValue(blockOption);

//         onChange((prev) => ({
//           ...prev,
//           block: blockOption,
//           grampanchayat: null,
//           majra: null,
//         }));
//       }
//     }
//   }, [firstBlock, districtValue, locationData]);

//   useEffect(() => {
//     if (firstgp && districtValue && blockValue && locationData?.length > 0) {
//       const district = locationData?.find(
//         (d) => d.value === districtValue.value
//       );
//       const block = district?.blocks?.find((b) => b.value === blockValue.value);
//       const gp = block?.GPs?.find(
//         (g) =>
//           g.value === firstgp ||
//           g.label === firstgp ||
//           g.label?.includes(firstgp)
//       );

//       if (gp) {
//         const gpOption = { label: gp.label, value: gp.value };
//         setGpValue(gpOption);

//         onChange((prev) => ({
//           ...prev,
//           grampanchayat: gpOption,
//           majra: null,
//         }));
//       }
//     }
//   }, [firstgp, blockValue, districtValue, locationData]);

//   const districts = locationData?.map((district) => ({
//     label: district.label,
//     value: district.value,
//   }));

//   const blocks = districtValue?.value
//     ? locationData?.find((d) => d.value === districtValue.value)
//         ?.blocks.map((b) => ({ label: b.label, value: b.value })) || []
//     : [];

//   const gps =
//     districtValue?.value && blockValue?.value
//       ? locationData?.find((d) => d.value === districtValue.value)
//           ?.blocks.find((b) => b.value === blockValue.value)
//           ?.GPs.map((gp) => ({ label: gp.label, value: gp.value })) || []
//       : [];

//   const majras =
//     districtValue?.value && blockValue?.value && gpValue?.value
//       ? locationData
//           .find((d) => d.value === districtValue.value)
//           ?.blocks.find((b) => b.value === blockValue.value)
//           ?.GPs.find((gp) => gp.value === gpValue.value)
//           ?.majras.map((m) => ({ label: m.label, value: m.value })) || []
//       : [];

//   const handleDistrictChange = (value) => {
//     setDistrictValue(value);
//     setBlockValue(null);
//     setGpValue(null);
//     setMajraValue(null);
//     onChange({
//       district: value,
//       block: null,
//       grampanchayat: null,
//       majra: null,
//     });
//   };

//   const handleBlockChange = (value) => {
//     setBlockValue(value);
//     setGpValue(null);
//     setMajraValue(null);
//     onChange({
//       district: districtValue,
//       block: value,
//       grampanchayat: null,
//       majra: null,
//     });
//   };

//   const handleGpChange = (value) => {
//     setGpValue(value);
//     setMajraValue(null);
//     onChange({
//       district: districtValue,
//       block: blockValue,
//       grampanchayat: value,
//       majra: null,
//     });
//   };

//   const handleMajraChange = (value) => {
//     setMajraValue(value);
//     onChange({
//       district: districtValue,
//       block: blockValue,
//       grampanchayat: gpValue,
//       majra: value,
//     });
//   };

//   const customStyles = {
//     control: (provided) => ({
//       ...provided,
//       minHeight: "40px",
//       height: "38px",
//       fontSize: "13px",
//       zIndex: 100,
//     }),
//     menu: (provided) => ({
//       ...provided,
//       zIndex: 3000,
//     }),
//   };

//   return (
//     <Row className="align-items-center position-relative">
//       <Col sm={width} className="mb-2">
//         <Select
//           options={districts}
//           value={districtValue}
//           onChange={handleDistrictChange}
//           placeholder="Select District"
//           styles={customStyles}
//           isClearable
//         />
//       </Col>
//       <Col sm={width} className="mb-2">
//         <Select
//           options={blocks}
//           value={blockValue}
//           onChange={handleBlockChange}
//           placeholder="Select Block"
//           isDisabled={!districtValue}
//           styles={customStyles}
//           isClearable
//         />
//       </Col> 
//       {GpRequired && (
//         <Col sm={width} className="mb-2">
//           <Select
//             options={gps}
//             value={gpValue}
//             onChange={handleGpChange}
//             placeholder="Select Grampanchayat"
//             isDisabled={!blockValue}
//             styles={customStyles}
//             isClearable
//           />
//         </Col>
//       )}
//       {majraRequired && (
//         <Col sm="3" className="mb-2">
//           <Select
//             options={majras}
//             value={majraValue}
//             onChange={handleMajraChange}
//             placeholder="Select Majra"
//             isDisabled={!gpValue}
//             styles={customStyles}
//             isClearable
//           />
//         </Col>
//       )} 
//     </Row>
//   );
// };

// export default OliveLocationFilters;




import React, { useState, useEffect } from "react";
import Select from "react-select";
import { Row, Col } from "react-bootstrap";
import { Alaap_dev, CMS_maati } from "urlconfig";
import { useTranslation } from "react-i18next";

const OliveLocationFilters = ({ onChange ,firstDistrict}) => {
  const [locationData, setLocationData] = useState([]);
  const [level2Value, setLevel2Value] = useState(null);
  const [level3Value, setLevel3Value] = useState(null);
  const [level4Value, setLevel4Value] = useState(null);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    fetch(`${Alaap_dev}/api/alaap-location-masters`)
      .then((res) => res.json())
      .then((data) => {
        const formatted = data?.data?.[0]?.data || [];
        setLocationData(formatted);
      })
      .catch((err) => console.error("Error fetching location data", err));
  }, []);

  const level2Options = locationData?.map((item) => ({
    label: item.level_2.label,
    value: item.level_2.value,
    level_3: item.level_2.level_3,
  }));

  const level3Options =
    level2Value?.level_3?.map((item) => ({
      label: item.label,
      value: item.value,
      level_4: item.level_4,
    })) || [];

  const level4Options =
    level3Value?.level_4?.map((item) => ({
      label: item.label,
      value: item.value,
    })) || [];

  const handleLevel2 = (val) => {
    setLevel2Value(val);
    setLevel3Value(null);
    setLevel4Value(null);
    onChange({
      level2: val,
      level3: null,
      level4: null,
    });
  };

  const handleLevel3 = (val) => {
    setLevel3Value(val);
    setLevel4Value(null);
    onChange({
      level2: level2Value,
      level3: val,
      level4: null,
    });
  };

  const handleLevel4 = (val) => {
    setLevel4Value(val);
    onChange({
      level2: level2Value,
      level3: level3Value,
      level4: val,
    });
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      height: "40px",
      minHeight: "40px",
      fontSize: "13px",
    }),
    menu: (p) => ({ ...p, zIndex: 99999 }),
  };

  return (
    <Row>
      <Col sm={4} className="mb-2">
        <Select
          options={level2Options}
          value={level2Value}
          onChange={handleLevel2}
          placeholder={t("Select District")}
          styles={customStyles}
          isClearable
        />
      </Col>

      <Col sm={4} className="mb-2">
        <Select
          options={level3Options}
          value={level3Value}
          onChange={handleLevel3}
          placeholder={t("Select Municipality")}
          isDisabled={!level2Value}
          styles={customStyles}
          isClearable
        />
      </Col>

      <Col sm={4} className="mb-2">
        <Select
          options={level4Options}
          value={level4Value}
          onChange={handleLevel4}
          placeholder={t("Select Parish")}
          isDisabled={!level3Value}
          styles={customStyles}
          isClearable
        />
      </Col>
    </Row>
  );
};

export default OliveLocationFilters;

